<template>
  <div
    ref="selectDayMonth"
    class="select-day-month"
    v-click-outside="hideBallon"
  >
    <div v-if="showBallons" class="ballon-area">
      <header :class="{ 'title-days': showDays }">
        <div class="header-year">
          <span
            v-show="nextYear == openedYearValue && !showDays"
            v-tooltip="btnYearLabel"
            class="arrow-nav arrow-left"
            @click.prevent.stop="changeYear"
          >
            <i class="fa fa-chevron-left"></i>
            <i class="fa fa-chevron-left"></i>
          </span>

          <span @click.prevent.stop="daysBack">
            {{ yearHeader }}
          </span>
          <span
            v-show="currentYear == openedYearValue && !showDays"
            v-tooltip="btnYearLabel"
            class="arrow-nav arrow-right"
            @click.prevent.stop="changeYear"
          >
            <i class="fa fa-chevron-right"></i>
            <i class="fa fa-chevron-right"></i>
          </span>
        </div>

        <div v-if="showDays" class="header-year">
          <span
            v-if="showBackMonth"
            v-tooltip="'Previous month'"
            class="arrow-nav arrow-left"
            role="button"
            @click.prevent.stop="backMonth"
          >
            <i class="fa fa-chevron-left"></i>
          </span>

          <span role="button" @click.prevent.stop="daysBack">
            {{ title }}
          </span>

          <span
            v-if="showNextMonth"
            v-tooltip="'Next month'"
            class="arrow-nav arrow-right"
            role="button"
            @click.prevent.stop="nextMonth"
          >
            <i class="fa fa-chevron-right"></i>
          </span>
        </div>
      </header>
      <ul
        :key="`monthList${openedYearValue}`"
        v-if="!showDays"
        class="months-area"
      >
        <li
          v-for="month in months"
          :key="month.value"
          role="button"
          @click.prevent.stop="selectMonth(month)"
          :class="[
            {
              selected:
                selectedMonth.value == month.value &&
                openedYearValue == selectedYear,
            },
            {
              disabled: isDasabeldMonth(month.value),
            },
          ]"
        >
          {{ month.code }}
          <span
            v-if="
              openedYearValue == selectedYear &&
              selectedMonth.value == month.value
            "
          >
            {{ selectedDay }}
          </span>
        </li>
      </ul>
      <ul v-else :key="`daysList${openedYearValue}`" class="days-area">
        <li
          v-for="day in days"
          :key="day"
          role="button"
          :class="[
            {
              selected:
                selectedDay == day &&
                openedMonthValue == selectedMonth.value &&
                openedYearValue == selectedYear,
            },
            {
              disabled: isDisabeldDay(day),
            },
          ]"
          @click.prevent="selectDay(day)"
        >
          {{ day }}
        </li>
      </ul>
    </div>
    <div
      :class="[{ 'opened-ballon': showBallons }, { disable: disable }]"
      class="selected-area"
      role="button"
      @click.prevent="callShowBallons"
    >
      {{ displayValue }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectDayMonth",

  props: {
    value: {
      type: String,
      required: false,
      default: "2020-1-1",
    },
    currentYear: {
      type: Number,
      required: false,
      default: () => {
        return new Date().getFullYear();
      },
    },
    nextYear: {
      type: Number,
      required: false,
      default: () => {
        return new Date().getFullYear() + 1;
      },
    },
    before: {
      type: String,
      required: false,
      default: "",
    },
    after: {
      type: String,
      required: false,
      default: "",
    },
    disable: {
      type: Boolean,
      required: false,
      default: false,
    },
    open: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data: function () {
    return {
      showDays: false,
      openedMonthValue: null,
      openedYearValue: null,
      months: [
        { value: 1, code: "jan", name: "January", days: 31 },
        { value: 2, code: "feb", name: "February", days: 28 },
        { value: 3, code: "mar", name: "March", days: 31 },
        { value: 4, code: "apr", name: "April", days: 30 },
        { value: 5, code: "may", name: "May", days: 31 },
        { value: 6, code: "jun", name: "June", days: 30 },
        { value: 7, code: "jul", name: "July", days: 31 },
        { value: 8, code: "aug", name: "August", days: 31 },
        { value: 9, code: "sep", name: "September", days: 30 },
        { value: 10, code: "oct", name: "October", days: 31 },
        { value: 11, code: "nov", name: "November", days: 30 },
        { value: 12, code: "dec", name: "December", days: 31 },
      ],
    };
  },

  computed: {
    yearHeader() {
      if (this.openedYearValue === this.currentYear) return "Current Year";

      return "Next Year";
    },
    showBallons: {
      get() {
        return this.open;
      },
      set(newValue) {
        this.$emit("update:open", newValue);
      },
    },
    btnYearLabel() {
      if (this.openedYearValue === this.currentYear) return "Go to next near";

      return `Back to current year`;
    },
    showBackMonth() {
      return (
        this.openedYearValue === this.nextYear ||
        (this.openedYearValue === this.currentYear && this.openedMonthValue > 1)
      );
    },
    showNextMonth() {
      return (
        this.openedYearValue === this.currentYear ||
        (this.openedYearValue === this.nextYear && this.openedMonthValue < 12)
      );
    },
    localValue: {
      get() {
        this.$emit("on-change", this.value);
        return this.value;
      },
      set(newValue) {
        this.$emit("on-change", newValue);
        this.$emit("input", newValue);
      },
    },
    title() {
      if (this.showDays) return this.openedMonth.name;

      return "";
    },
    selectedDay() {
      let day = 1;
      const data = this.value.split("-");

      if (data && data.length) day = data[2];

      return day;
    },
    beforeYear() {
      if (!this.before) return null;

      const data = this.before.split("-");

      return parseInt(data[0]);
    },
    beforeMonth() {
      if (!this.before) return null;

      const data = this.before.split("-");

      return parseInt(data[1]);
    },
    beforeDay() {
      if (!this.before) return null;

      const data = this.before.split("-");

      return parseInt(data[2]);
    },
    afterYear() {
      if (!this.after) return null;

      const data = this.after.split("-");

      return parseInt(data[0]);
    },
    afterMonth() {
      if (!this.after) return null;

      const data = this.after.split("-");

      return parseInt(data[1]);
    },
    afterDay() {
      if (!this.after) return null;

      const data = this.after.split("-");

      return parseInt(data[2]);
    },
    selectedMonth() {
      const data = this.value.split("-");

      return this.months.find((month) => month.value == data[1]);
    },
    selectedYear() {
      const data = this.value.split("-");

      return data[0];
    },
    openedMonth() {
      return this.months.find((month) => month.value == this.openedMonthValue);
    },
    days() {
      const days = [];
      const month = this.months.find(
        (month) => month.value == this.openedMonthValue
      );

      for (let i = 1; i <= month.days; i++) {
        days.push(i);
      }

      return days;
    },
    displayValue() {
      if (
        !this.selectedMonth ||
        (this.selectedMonth && !this.selectedMonth.code)
      )
        return `error ${this.selectedDay}`;
      return `${this.selectedMonth.code} ${this.selectedDay}`;
    },
  },

  mounted() {
    this.openedYearValue = parseInt(this.value.split("-")[0]);
  },

  methods: {
    isLeap(year) {
      return new Date(year, 1, 29).getDate() === 29;
    },
    changeYear() {
      this.showDays = false;
      this.openedYearValue == this.nextYear
        ? (this.openedYearValue = this.currentYear)
        : (this.openedYearValue = this.nextYear);

      this.months[1].days = this.openedYearValue ? 29 : 28;
    },
    selectMonth(month = this.months[0]) {
      this.openedMonthValue = month.value;
      this.showDays = true;
    },
    selectDay(day = 1) {
      this.localValue = `${this.openedYearValue}-${this.openedMonthValue}-${day}`;
      this.hideBallon();
    },
    hideBallon() {
      this.showBallons = false;
      this.showDays = false;
    },
    daysBack() {
      this.showDays = false;
      this.showBallons = true;
    },
    isDasabeldMonth(month) {
      const isDiable =
        (this.beforeYear && this.openedYearValue > this.beforeYear) ||
        (this.afterYear && this.openedYearValue < this.afterYear) ||
        (this.beforeMonth &&
          this.openedYearValue === this.beforeYear &&
          (month > this.beforeMonth ||
            (month === this.beforeMonth && this.beforeDay == 1))) ||
        (this.afterMonth &&
          this.openedYearValue === this.afterYear &&
          (month < this.afterMonth ||
            (month === this.afterMonth &&
              this.afterDay === this.getLastMonthDay(month))))
          ? true
          : false;

      return isDiable;
    },
    isDisabeldDay(day) {
      let isDiable;

      if (
        (this.beforeMonth &&
          this.openedYearValue === this.beforeYear &&
          this.openedMonthValue == this.beforeMonth &&
          this.beforeDay &&
          day >= this.beforeDay) ||
        (this.afterMonth &&
          this.openedYearValue === this.afterYear &&
          this.openedMonthValue == this.afterMonth &&
          this.afterDay &&
          day <= this.afterDay)
      ) {
        isDiable = true;
      } else {
        isDiable = false;
      }
      return isDiable;
    },
    getLastMonthDay(month) {
      return this.months.find((item) => item.value == month).value;
    },
    callShowBallons() {
      this.openedYearValue = parseInt(this.value.split("-")[0]);
      if (!this.disable) this.showBallons = true;
    },
    backMonth() {
      if (this.openedMonthValue > 1) {
        this.openedMonthValue--;
        this.showDays = true;
      } else if (
        this.openedMonthValue == 1 &&
        this.openedYearValue === this.nextYear
      ) {
        this.openedYearValue = this.currentYear;
        this.openedMonthValue = 12;
      }
    },
    nextMonth() {
      if (this.openedMonthValue < 12) {
        this.openedMonthValue++;
        this.showDays = true;
      } else if (
        this.openedMonthValue == 12 &&
        this.openedYearValue === this.currentYear
      ) {
        this.openedYearValue = this.nextYear;
        this.openedMonthValue = 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$font-color-default: #555;
$item-background-color: #00a4cd;
$item-background-color-dark: #047b99;
$item-color-soft: #f1f1f1;
$transition-delay: 0.3s;
$border-default: 1px solid #dbdbdb;

.select-day-month {
  position: relative;
  z-index: 10px;

  .selected-area {
    cursor: pointer;
    position: relative;
    padding-left: 5px;
    padding-right: 5px;
    margin-left: 5px;
    margin-right: 5px;
    z-index: 10;
    border-bottom: $border-default;
    transition: all ease $transition-delay;

    &:hover:not(.disable) {
      background-color: $item-color-soft;
    }

    &.disable {
      border-bottom: 1px solid transparent;
      cursor: default;
    }

    &.opened-ballon {
      border-bottom: 2px solid;
      background-color: $item-color-soft;
      transition: all ease $transition-delay;
    }

    &::first-letter {
      text-transform: uppercase;
    }
  }

  .ballon-area {
    z-index: 20;
    border: $border-default;
    padding: 10px;
    position: absolute;
    width: 200px;
    background-color: rgb(253, 253, 253);
    top: 28px;
    border-radius: 5px;
    -webkit-box-shadow: 0px 9px 23px -12px rgba(0, 0, 0, 0.79);
    box-shadow: 0px 9px 23px -12px rgba(0, 0, 0, 0.79);
    transition: all ease $transition-delay;

    .btn-area {
      position: relative;

      .ballon-close {
        opacity: 0.5;
        position: absolute;
        right: -5px;
        top: -5px;
        cursor: pointer;
        transition: opacity ease $transition-delay;

        &:hover {
          opacity: 0.8;
          transition: opacity ease $transition-delay;
          border: 1px solid $item-background-color;
        }
      }
    }

    header {
      text-align: center;
      text-transform: capitalize;
      font-size: 1rem;
      margin-bottom: 5px;
      color: $font-color-default;
      padding: 0px 0px 5px 0px;

      .header-year {
        position: relative;

        .arrow-nav {
          position: absolute;
          margin-top: 1px;

          &.arrow-left {
            left: 0px;
          }

          &.arrow-right {
            right: 0px;
          }
        }
      }

      &.title-days {
        cursor: pointer;
      }
    }

    .months-area {
      display: flex;
      flex-wrap: wrap;
      gap: 0px;

      li {
        color: $font-color-default;
        background-color: white;
        width: 55px;
        padding: 10px 0px;
        flex-grow: 1;
        text-align: center;
        cursor: pointer;
        transition: background-color ease $transition-delay;

        &.selected {
          background-color: $item-background-color;
          color: white;
          transition: background-color ease $transition-delay;
        }

        &:hover {
          background-color: $item-background-color-dark;
          color: white;
        }

        &::first-letter {
          text-transform: uppercase;
        }
      }
    }

    .days-area {
      display: flex;
      flex-wrap: wrap;

      li {
        color: $font-color-default;
        width: 35px;
        padding: 3px;
        text-align: center;
        background-color: white;
        cursor: pointer;
        transition: background-color ease $transition-delay;

        &.selected {
          background-color: $item-background-color;
          color: white;
          transition: background-color ease $transition-delay;
          font-weight: bold;
        }

        &:hover {
          background-color: $item-background-color-dark;
          color: white;
        }

        &::first-letter {
          text-transform: uppercase;
        }
      }

      .back-item {
        flex-grow: 1;
        width: 70px;
        opacity: 0.8;
        color: white;

        &:hover {
          opacity: 1 !important;
          color: white;
        }
      }
    }
  }
}

.disabled {
  color: #ccc !important;
  cursor: not-allowed !important;
}

.arrow-nav {
  font-weight: 100;
  font-size: 0.8rem;
  margin-top: 5px;
  cursor: pointer;

  i {
    font-weight: 100;
  }

  &.arrow-left {
    float: left;
    cursor: pointer;
    padding: 2px 7px 2px 7px;
  }

  &.arrow-right {
    float: right;
    cursor: pointer;
    padding: 2px 7px 2px 7px;
  }
}
</style>
